<script setup lang="tsx">
import SectionContainer from '../SectionContainer/SectionContainer.vue';
import PlannerCard, { type Props } from './PlannerCard.vue';
import ImgPlanner1 from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/IndexTemplate/IndexPlanners/planner1.jpg/planner1.webp';
import ImgPlanner2 from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/IndexTemplate/IndexPlanners/planner2.jpg/planner2.webp';
import ImgPlanner3 from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/IndexTemplate/IndexPlanners/planner3.jpg/planner3.webp';
import ImgPlanner4 from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/IndexTemplate/IndexPlanners/planner4.jpg/planner4.webp';
import ImgPlanner5 from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/IndexTemplate/IndexPlanners/planner5.jpg/planner5.webp';
import ImgPlanner6 from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/IndexTemplate/IndexPlanners/planner6.jpg/planner6.webp';
import type { Component } from 'vue';

const style = useCssModule();
const planners: {
  imgPath: string;
  body: string | Component<unknown>;
  props: Props;
}[] = [
  {
    imgPath: ImgPlanner1,
    body: 'お金とうまく付き合うための第一歩は、自分の送りたい人生を描くことです。私は、お金は手段だと常々考えています。だから最初に、自分はなにをしたいのかどんな人生を生きていきたいのかというビジョンを描くところからまずは一緒にはじめていきましょう。「これから」を見据えたお金との心地よい関係について一緒に考えていけたら幸いです。',
    props: {
      name: '金子 智',
      appeal: '落語仕込みのわかりやすい説明が好評！',
      tags: [
        '家計改善',
        'ライフプランニング',
        '教育資金',
        '保険',
        '資産運用',
        '老後資金',
        '相続',
        '投資/お金の勉強',
      ],
    },
  },
  {
    imgPath: ImgPlanner2,
    body: '証券会社にて、個人のお客様の資産運用・次世代への資産承継のご相談を承ってまいりました。より幅広い年代のお客様に様々な金融サービスをお届けできるFPになりたいと400Fに入社し、オンラインアドバイザーとして活動しております。お一人おひとりの状況や人生の目標を伺いながら最適なアドバイスをお届けさせていただきます。お仕事がお忙しい現役世代の方もセカンドライフをお楽しみの方もお気軽にご相談くださいませ。',
    props: {
      name: '日比谷 絵理',
      appeal: '子育て世代から退職後までの悩みに寄り添います',
      tags: [
        'ライフプランニング',
        '教育資金',
        '保険',
        '資産運用',
        '老後資金',
        '相続',
        '投資/お金の勉強',
      ],
    },
  },
  {
    imgPath: ImgPlanner3,
    body: '野村證券株式会社に5年間在籍、未上場法人から個人のお客様まで幅広く合計1500名以上のお客様を担当。年間1000件以上の面談・アドバイスを実施。金融オンライン・アドバイザーとして「お客様視点であり、無駄なコストをかけないこと」を重視し、資産運用・保険の見直し・ライフプランニング・相続などさまざまなお金の悩みに寄り添い、年齢、性別を問わず、幅広く多くのお客様へご対応させて頂いております。',
    props: {
      name: '村山 努',
      appeal: 'テクノロジーの力で多くの方の身近な存在に',
      tags: [
        '家計改善',
        'ライフプランニング',
        '教育資金',
        '保険',
        '資産運用',
        '老後資金',
        '相続',
        '富裕層',
        '投資/お金の勉強',
      ],
    },
  },
  {
    imgPath: ImgPlanner4,
    body: (_) => (
      <div>
        株式会社400Fに所属しております、金融オンラインアドバイザーの松本結衣と申します。
        <br />
        お金に対する漠然とした不安はあるものの、なかなか行動に移せずにいる方はたくさんいらっしゃるかと思います。オカネコを通して、気軽な気持ちで一歩踏み出して頂けると嬉しいです。お客様の不安やお悩みの解決に向けて、誠心誠意お手伝いをさせていただきます。
      </div>
    ),
    props: {
      name: '松本 結衣',
      appeal: '住宅購入の相談はお任せください',
      tags: [
        '家計改善',
        'ライフプランニング',
        '教育資金',
        '保険',
        '資産運用',
        '住宅ローン',
        '老後資金',
        '不動産',
        '投資/お金の勉強',
      ],
    },
  },
  {
    imgPath: ImgPlanner5,
    body: (_) => (
      <div>
        このようなご相談をいただいております。
        <ul class={style['planner__listing']}>
          <li>「資産形成って何から始めればいいの？」</li>
          <li>「ライフプランニングをしてほしい」</li>
          <li>「NISAやiDeCoについて教えてほしい」</li>
          <li>「今加入している保険は本当に必要なの？」など</li>
        </ul>
        どんな些細な事でも結構です。お客様のペース・目線で丁寧にわかりやすくお話しさせていただきます。
      </div>
    ),
    props: {
      name: '伴海 大介',
      appeal: '全国各地にお住まいのお客様に対応します',
      tags: [
        '家計改善',
        'ライフプランニング',
        '教育資金',
        '保険',
        '資産運用',
        '老後資金',
      ],
    },
  },
  {
    imgPath: ImgPlanner6,
    body: '「老後資金が不安」「運用をしてみたいけど何から始めてたらいいかわからない」「教育資金はどれくらい必要なんだろう」など、お気軽にご相談ください。私自身、子供が生まれてからは特に教育資金や老後資金、万が一の備えなどについてよく考える必要があると感じるようになりました。お子様同席でのご相談も歓迎です。一緒に将来について考えていきましょう。',
    props: {
      name: '西村 蘭',
      appeal: '多角的な視点が強み！納得感のあるご提案を',
      tags: [
        'ライフプランニング',
        '教育資金',
        '資産運用',
        '老後資金',
        '投資/お金の勉強',
      ],
    },
  },
];
</script>

<template>
  <div>
    <SectionContainer
      heading="あなたに合うアドバイザーが見つかる!"
      subheading="online advisor"
    >
      <template #description>
        <div :class="$style.header__body">
          オカネコ専任の金融オンライン・アドバイザーに加え、<br />
          保険代理店・IFA事業者など250社と連携し、経験豊富な600名以上のお金のプロに相談できます。
        </div>
        <div :class="$style.header__notice">
          ※ 2024年6月24日時点当社データベースより概算
        </div>
      </template>
    </SectionContainer>
    <div :class="$style.planners">
      <template v-for="n in 3" :key="n">
        <PlannerCard
          v-for="p in planners"
          :key="`${p.imgPath}:${n}`"
          v-bind="p.props"
        >
          <template #avatar><img :src="p.imgPath" /></template>
          <template v-if="typeof p.body === 'string'">{{ p.body }}</template>
          <component :is="p.body" v-else />
        </PlannerCard>
      </template>
    </div>
  </div>
</template>

<style module lang="scss">
.planners {
  display: flex;
  width: v-bind('`${(360 + 24) * planners.length * 3}px`');
  gap: 24px;

  animation: 40s linear 0s infinite running carousel;
  @keyframes carousel {
    to {
      transform: translateX(v-bind('`-${(360 + 24) * planners.length}px`'));
    }
  }
}
.header {
  &__body {
    text-align: center;
  }
  &__notice {
    margin-top: 16px;
    font-size: 10px;
  }
}

.planners {
  margin-top: 24px;
}

.planner {
  &__listing {
    list-style: disc;
    padding-left: 1.5em;
  }
}
</style>
